import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGroups, getMarkets, getMatches, getMatchesInfoRequest, getMatchesSummary, getUserPredictions } from "../../../redux/predictor";

/**
 * Custom hook for managing predictions data fetching and Redux state
 * @param {Object} fansUnitedSDK - The FansUnited SDK instance
 * @returns {Object} - Data and loading state
 */
export const usePredictionsData = (fansUnitedSDK) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	// Redux selectors
	const matches = useSelector(getMatches);
	const availableMarkets = useSelector(getMarkets, (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue));
	const userPredictions = useSelector(getUserPredictions, (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue));
	const summary = useSelector(getMatchesSummary);
	const groups = useSelector(getGroups);

	/**
	 * Fetch all predictions data
	 * @returns {Promise} - Promise that resolves when data is loaded
	 */
	const getData = useCallback(() => {
		setIsLoading(true);
		return dispatch(getMatchesInfoRequest(fansUnitedSDK))
			.then(() => {
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
				throw error;
			});
	}, [dispatch, fansUnitedSDK]);

	return {
		matches,
		availableMarkets,
		userPredictions,
		summary,
		groups,
		isLoading,
		getData,
	};
};
